import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const GadgetLoader = ({ loading }) => {
    return loading ? (
        <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            borderRadius: "8px"
        }}>
            <CircularProgress />
        </div>
    ) : null;
};

export default GadgetLoader;
